import styled from "styled-components";

import {
  alignItemsCenter,
  alpha,
  bp,
  circle,
  flexCenter,
  flexColumn,
  media,
  rem,
  size,
} from "@styles/Utilities.styled";


export const StyledTimeline = styled.section`
  position: relative;
  margin-top: 2rem;
  margin-bottom: 10rem;

  .header {
    padding-top: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid ${alpha("var(--clr-black)", 0.1)};

    h2 {
      font-size: ${rem(20)};
      font-weight: 500;
    }
  }

  .timeline-header {
    ${alignItemsCenter}
    gap: 2rem;
    position: sticky;
    top: 0;
    padding-top: 2rem;
    padding-bottom: 1rem;
    background-color: white;
    z-index: 1;

    .filter-wrapper {
      ${alignItemsCenter}
      gap: 1rem;
    }

    .SelectTrigger {
      gap: ${rem(15)};
    }

    p {
      white-space: nowrap;
      color: var(--clr-primary-400);
      font-weight: 500;
    }

    .filter-tags {
      ${alignItemsCenter}
      gap: 0.5rem;

      &-item {
        ${alignItemsCenter}
        gap: 0.5em;
        width: fit-content;
        font-size: ${rem(14)};
        font-weight: 500;
        padding: 0.4em 0.6em;
        line-height: 1;
        border-radius: var(--border-radius-2);
        color: var(--clr-primary-400);
        background-color: var(--clr-primary-100);
        text-transform: capitalize;

        button {
          ${flexCenter}
          color: var(--clr-primary-400);

          svg {
            font-size: ${rem(15)};
          }
        }
      }
    }
  }

  .timeline {
    --timeline-gap: 3rem;

    ${flexColumn}
    gap: var(--timeline-gap);
    margin-top: 1rem;

    .empty-label {
      color: var(--clr-gray-400);
      font-size: ${rem(14)};
    }

    &-item {
      --date-width: 12ch;
      --circle-size: ${rem(15)};

      position: relative;
      display: flex;
      align-items: start;
      gap: 4rem;
      /* outline: 1px solid red; */

      &:last-child {
        overflow: hidden;
      }

      .date {
        font-size: ${rem(14)};
        color: var(--clr-gray-400);
        width: var(--date-width);
        text-align: right;
      }

      .decor {
        --position-adjustment: -1.5ch;

        ${media(bp.medium)} {
          --position-adjustment: -0.75ch;
        }
        ${media(bp.large3)} {
          --position-adjustment: -0.5ch;
        }

        &-1 {
          position: absolute;
          top: 0;
          left: calc(var(--date-width) + var(--position-adjustment));
          ${circle("var(--circle-size)")}
          background-color: var(--clr-white);
          border: 2px solid var(--clr-gray-300);
        }

        &-2 {
          position: absolute;
          top: var(--circle-size);
          left: calc(
            var(--date-width) + (var(--circle-size) / 2) +
              var(--position-adjustment)
          );
          transform: translateX(-50%);
          ${size("1px", "calc(100% + var(--timeline-gap))")}
          background-color: var(--clr-gray-200);
        }
      }
    }

    &-events {
      ${flexColumn}
      gap: 1.5rem;
      width: 100%;

      &-item {
        position: relative;
        ${flexColumn}
        width: 100%;
        gap: 0.5rem;
        /* outline: 1px solid blue; */

        &:first-child {
          .decor {
            display: none;
          }
        }

        .decor {
          position: absolute;
          ${circle(rem(10))}
          top: 5px;
          left: -2rem;
          transform: translateX(-50%);
          background-color: var(--clr-primary-400);

          ${media(bp.large2)} {
            transform: translateX(-78%);
          }
          ${media(bp.large3)} {
            transform: translateX(-85%);
          }

          &.consultation {
            background-color: var(--blue-10);
          }

          &.footnote {
            background-color: var(--clr-yellow);
          }

          &.laboratory {
            background-color: var(--clr-rose);
          }

          &.radiology {
            background-color: var(--clr-primary-400);
          }

          &.prescription {
            background-color: var(--green-10);
          }

          &.immunization {
            background-color: var(--orange-10);
          }
          &.treatment {
            background-color: var(--lime-10);
          }
          &.injection {
            background-color: var(--brown-10);
          }
        }

        .label {
          width: fit-content;
          font-size: ${rem(11)};
          font-weight: 500;
          padding: 0.2em 0.8em;
          /* line-height: 1; */
          border-radius: 100vmax;
          text-transform: capitalize;

          &.consultation {
            color: var(--blue-10);
            background-color: var(--blue-4);
          }

          &.footnote {
            color: var(--clr-yellow);
            background-color: ${alpha("var(--clr-yellow)", 0.1)};
          }

          &.laboratory {
            color: var(--clr-rose);
            background-color: ${alpha("var(--clr-rose)", 0.1)};
          }

          &.radiology {
            color: var(--clr-primary-400);
            background-color: var(--clr-primary-100);
          }

          &.prescription {
            color: var(--green-10);
            background-color: var(--green-4);
          }

          &.immunization {
            color: var(--orange-10);
            background-color: var(--orange-4);
          }

          &.treatment {
            color: var(--lime-11);
            background-color: var(--lime-4);
          }

          &.injection {
            color: var(--brown-11);
            background-color: var(--brown-4);
          }
        }

        .text-wrapper {
          ${flexColumn}
          gap: 0.25rem;
          margin-top: 0.5rem;

          .title {
            line-height: 1;
            font-weight: 500;
          }

          .doctor {
            font-size: ${rem(13)};
            font-weight: 300;
          }
        }
      }
    }
  }
`;
